import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { toast } from 'react-toastify';
import styled from "styled-components";
import { colors } from "../../utils";
import { device } from "../../utils/device";
import TextView from "../TextView";
import Button from "../Button";

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0000006f;
`;

const ModalContent = styled.div`
  background-color: white;
  outline: none;
  position: relative;
  width: 80vw;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (${device.mobilePortrait}){
    width: 100vw;
    height: 50vh;
  }

`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 10vh;
  align-items: center;
  padding: 3vh 3vw;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75vw;
  height: 75vh;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const NavigationContainer = styled.div`
  position: absolute;
  width: 88vw;
  top: 42vh;
  display: flex;
  justify-content: space-between;
`;
const NavigationButton = styled(IconButton)``;

const ImageModal = ({ open, handleClose, images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : images.length - 1
    );
  };

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < images.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handleDownloadImage = () => {
    const imageUrl = images[currentIndex]?.src;
  
    if (!imageUrl) {
      toast.error("No image available to open");
      return;
    }
  
    // Open the image in a new tab
    window.open(imageUrl, '_blank');
  };

  const handlecopyToClipboard = () => {
    navigator.clipboard
      .writeText(images[currentIndex]?.src)
      .then(() => {
        toast.success("Image copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };


  return (
    <StyledModal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <ModalContent>
          <ModalHeader>
            <TextView variant="title">{images[currentIndex].title || "Untitled Image"}</TextView>
            <ButtonsContainer>
              {/* <Button
                style={{
                  backgroundColor: colors.lightPurple,
                  fontSize: 14,
                  height: 38,
                  fontWeight: 700,
                }}
              >
                View on wheel
              </Button>
              <IconButton onClick={handlecopyToClipboard}>
                <ShareIcon style={{ color: colors.purple }} />
              </IconButton> */}
              <IconButton onClick={handleClose}>
                <CloseIcon style={{ color: colors.purple }} />
              </IconButton>
            </ButtonsContainer>
          </ModalHeader>
          <ImageContainer>
            <Image src={images[currentIndex].src} alt="modal-img" />
          </ImageContainer>
          {images.length > 1 && (
            <NavigationContainer>
              <NavigationButton onClick={handlePrevImage}>
                <ArrowBackIcon style={{ color: "white", fontSize: 28 }} />
              </NavigationButton>
              <NavigationButton onClick={handleNextImage}>
                <ArrowForwardIcon style={{ color: "white", fontSize: 28 }} />
              </NavigationButton>
            </NavigationContainer>
          )}
        </ModalContent>
      </Fade>
    </StyledModal>
  );
};

export default ImageModal;
